/**
 * Limits for Inventory Quick Compare query params (`quickComparePrimary` / `quickCompareCompare`).
 * Browsers and proxies often cap total URL length (~2k); keep encoded param values conservative.
 */
export const QUICK_COMPARE_MAX_PARAM_VALUE_CHARS = 900;

/** Reject pathological query strings before parsing as URLs. */
export const QUICK_COMPARE_MAX_RAW_PARAM_CHARS = 16_384;

export function canSyncQuickCompareUrlsToQueryParams(
  primaryUrl: string,
  compareUrl: string
): boolean {
  const p = (primaryUrl || '').trim();
  const c = (compareUrl || '').trim();
  if (!p || !c) return false;
  return p.length <= QUICK_COMPARE_MAX_PARAM_VALUE_CHARS && c.length <= QUICK_COMPARE_MAX_PARAM_VALUE_CHARS;
}

export function quickCompareQueryParamValueTooLarge(raw: string | null): boolean {
  if (raw == null) return false;
  return raw.length > QUICK_COMPARE_MAX_RAW_PARAM_CHARS;
}
